import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

/**
 * Heading of a top-level section in the Sparte dialogs, with an optional
 * one-line explanation below and actions on the right.
 */
export default function ClaimFormSparteDialogHeading({
  children,
  description,
  actions,
}) {
  return (
    <Box mb={1.5}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          {children}
        </Typography>
        {actions && (
          <Box display="flex" alignItems="center" gap={0.5} ml="auto">
            {actions}
          </Box>
        )}
      </Box>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
}

ClaimFormSparteDialogHeading.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.node,
  actions: PropTypes.node,
};
